import React from "react";

export default function Results({ sleepType, bestTimes, time }) {
    const formattedTime = `${time.hour.padStart(2, '0')}:${time.minute.padStart(2, '0')}`;

    // Helper function to format sleep time
    const formatSleepTime = (hours) => {
        const wholeHours = Math.floor(hours);
        const minutes = Math.round((hours - wholeHours) * 60);
        if (minutes === 0) {
            return `${wholeHours}h de sommeil`;
        }
        return `${wholeHours}h${minutes.toString().padStart(2, '0')} de sommeil`;
    };

    const introMsg = (sleepType, formattedTime) => {
        if (sleepType == 'wakeUp') {
            return `Pour vous sentir pleinement reposé à ${formattedTime}, les heures idéales pour aller au lit sont :`
        } else if (sleepType == 'sleep') {
            return `Si vous vous couchez à ${formattedTime}, pour bénéficier d'un sommeil réparateur, les heures idéales pour vous réveiller sont :`
        }
    }

    return (
        <>
            <div className="p-4 my-2 sm:my-4 rounded-lg w-full bg-gradient-to-b from-sky-900 to-sky-700 text-white text-sm sm:text-base">
                <p className="text-amber-400">{introMsg(sleepType, formattedTime)}</p>
                <div className="my-6 flex flex-wrap gap-2 w-full justify-center">
                    {[...bestTimes].reverse().map((h, i) => (
                        <div key={i} className="bg-sky-600 px-4 py-2 shadow-sm rounded-lg flex items-center gap-2 w-56 justify-start cursor-default">
                            <div className="text-3xl font-bold">{h}</div>
                            <div className="">
                                <div className="text-xs">
                                    {(6 - i) === 1 ? '1 cycle' : `${6 - i} cycles`}
                                </div>
                                <div className="text-xs">
                                    {formatSleepTime((6 - i) * 1.5)}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="text-sm">
                    <p className="mb-2">En moyenne, il faut <span className="font-bold">15 minutes pour s'endormir.</span></p>
                    <p className="mb-2">En vous réveillant à ces heures, vous vous lèverez entre les cycles de sommeil de 90 minutes. </p>
                    <p className=""><span className="font-semibold">Une bonne nuit inclut 5 à 6 cycles complets.</span></p>
                </div>
            </div>
        </>
    );
}
